<template>
  <router-link :to="{name: 'commodity', params: {id: this.item.id}}">
    <card no-body
          class="border-1 border-main-color overflow-hidden position-relative cursor-pointer">
      <div class="px-3 py-2">
      <div class="row align-items-center">
        <div class="d-flex align-items-center justify-content-center overflow-hidden" style="width: 48px; height: 70px;">
          <p class="m-0 font-size-60 font-weight-900 text-main-color lh-0">{{ index }}</p>
        </div>
        <div v-if="getMediaUrl() === undefined"
             class="rounded img-center img-fluid shadow shadow-sm--hover img position-relative"
             style="height: 70px; width: 70px;"
        >
          <EmptyImage></EmptyImage>
        </div>
        <img v-else v-lazy=getMediaUrl()
             class="rounded img-center img-fluid shadow shadow-sm--hover img">
        <div class="col ml-1">
          <div class="row justify-content-around">
            <!--            {{ isPreOrder }}-->
            <TagItem v-if="item.is_pre_order !== false"
                     :text="'預定'"
                     :color="this.$tagItemType.Red"
            />
            <TagItem v-if="item.is_pre_order === false"
                     :text="'庫存'"
                     :color="this.$tagItemType.Yellow"
            />
            <div>
              <p class="m-0 font-size-12 text-custom-remain-time font-weight-500">還剩 {{
                  timeLeft(item.final_date)
                }}</p>
            </div>
          </div>
          <p class="m-0 text-custom-text font-size-11 font-weight-500">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </card>
  </router-link>
</template>

<script>

import TagItem from "@/views/components/elements/TagItem";
import {getMediaUrl} from "@/util/helpers";
import {timeLeft} from "@/util/formatter";
import EmptyImage from "@/components/EmptyImage.vue";

export default {
  name: "rank_item",
  components: {
    EmptyImage,
    TagItem: TagItem,
  },
  props: {
    index: {
      type: Number,
      default: 1,
    },
    item: Object,
  },
  methods: {
    timeLeft,
    getMediaUrl() {
      if (this.item.Images.length > 0) return getMediaUrl(this.item.Images[0]);
      return undefined;
    },
  }
}
</script>

<style scoped>
.img {
  width: 70px;
  height: 70px;
  object-fit: cover;

}
</style>

